import { useFlush } from 'app/components/flush/useFlush'
import { FlushComponent } from 'app/components/flush/FlushComponent'
import { useEffect } from 'react'
import { useUser } from 'app/utils'
import { useNavigate } from 'react-router-dom'

export default function Flush() {
  const user = useUser()
  const navigate = useNavigate()
  const { pattern, setPattern, flushing, message, flush } = useFlush()

  useEffect(() => {
    if (!user || user.type !== `super`) navigate(`/`)
  }, [user])

  return (
    <FlushComponent
      pattern={pattern}
      onPatternChange={setPattern}
      flushing={flushing}
      message={message}
      onFlush={flush}
    />
  )
}
